import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiOperationStatus } from '../../../../shared/data-model/models/api-operation-status.model';
import { ApiGatewayService } from '../../../../shared/services/api-gateway/api-gateway.service';
import { ApiCurrentUser } from '../../../data-model/models/api-current-user.model';

@Injectable({ providedIn: 'root' })
export class AuthService {
  constructor(private readonly apiGatewayService: ApiGatewayService) {}

  checkToken(): Observable<ApiOperationStatus> {
    return this.apiGatewayService.get('common/accounts/checkToken');
  }

  signIn(username: string, password: string): Observable<ApiCurrentUser> {
    return this.apiGatewayService.post('oss/accounts/signin', { username, password }, false);
  }

  signOut(): Observable<ApiOperationStatus> {
    return this.apiGatewayService.post('common/accounts/signout', {}, false);
  }
}
